type ErrorListener = (error: string | null) => void;

class ErrorManager {
  private static instance: ErrorManager;
  private listeners: ErrorListener[] = [];
  private currentError: string | null = null;
  private debounceTimeout: any = null;

  private constructor() { }

  static getInstance(): ErrorManager {
    if (!ErrorManager.instance) {
      ErrorManager.instance = new ErrorManager();
    }
    return ErrorManager.instance;
  }

  showError(message: string): void {
    // Skip if same message is already showing
    if (this.currentError === message) {
      return;
    }

    // Show first error immediately
    if (!this.debounceTimeout) {
      this.currentError = message;
      this.notifyListeners();

      this.debounceTimeout = setTimeout(() => {
        this.debounceTimeout = null;
      }, 1000);
    }
  }

  clearError(): void {
    if (this.debounceTimeout) {
      clearTimeout(this.debounceTimeout);
      this.debounceTimeout = null;
    }
    this.currentError = null;
    this.notifyListeners();
  }

  getCurrentError(): string | null {
    return this.currentError;
  }

  addListener(listener: ErrorListener): void {
    this.listeners.push(listener);
  }

  removeListener(listener: ErrorListener): void {
    this.listeners = this.listeners.filter(l => l !== listener);
  }

  private notifyListeners(): void {
    this.listeners.forEach(listener => listener(this.currentError));
  }
}

export default ErrorManager.getInstance();